<template>
  <div class="order-stat">
    <div class="searchNav">
      <div class="search-form">
        <div class="search-items">
          <div class="search-item">
            <span class="label">订单号：</span>
            <el-input v-model="searchInfo.orderNo" clearable placeholder="请输入商家订单号"></el-input>
          </div>
          <div class="search-item">
            <span class="label">是否成功：</span>
            <el-select v-model="searchInfo.succeed" clearable placeholder="请选择">
              <el-option label="成功" :value="true"></el-option>
              <el-option label="失败" :value="false"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">快递公司：</span>
            <el-select v-model="searchInfo.shipperCode" clearable placeholder="请选择快递公司">
              <el-option label="中通" value="ZTO"></el-option>
              <el-option label="圆通" value="YTO"></el-option>
              <el-option label="申通" value="STO"></el-option>
              <el-option label="顺丰" value="SF"></el-option>
              <el-option label="韵达" value="YUNDA"></el-option>
              <el-option label="京东" value="JD"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">运单号：</span>
            <el-input v-model="searchInfo.logisticCode" clearable placeholder="请输入运单号"></el-input>
          </div>
          <div class="search-item">
            <span class="label">状态码：</span>
            <el-input v-model="searchInfo.state" clearable placeholder="请输入状态码"></el-input>
          </div>
          <div class="search-item">
            <span class="label">快递鸟单号：</span>
            <el-input v-model="searchInfo.kdnOrderCode" clearable placeholder="请输入快递鸟订单号"></el-input>
          </div>
        </div>
      </div>
      <div class="search-btn">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
      </div>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" max-height="650px">
        <el-table-column type="index" width="55"></el-table-column>
        <el-table-column prop="orderNo" label="订单号" width="170" show-overflow-tooltip></el-table-column>
        <el-table-column prop="stateDesc" label="状态说明" width="120" show-overflow-tooltip></el-table-column>

        <!-- <el-table-column prop="requestType" label="指令" width="140">
          <template slot-scope="scope">
            <el-tag size="mini" type="info">{{ formatRequestType(scope.row.requestType) }}</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column prop="succeed" label="处理结果" width="110">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.succeed ? 'success' : 'danger'">
              {{ scope.row.succeed ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="shipperCode" label="快递公司" width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatShipperCode(scope.row.shipperCode) }}
          </template>
        </el-table-column>
        <el-table-column prop="logisticCode" label="运单号" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="kdnOrderCode" label="快递鸟单号" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="state" label="状态码" width="90"></el-table-column>
        <el-table-column prop="pushTime" label="推送时间" width="170" show-overflow-tooltip></el-table-column>
        <el-table-column prop="callbackCreateTime" label="回调创建时间" width="170" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" show-overflow-tooltip></el-table-column>
        <el-table-column prop="errorMsg" label="失败原因" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.errorMsg || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openJsonDialog(scope.row, 'request')">请求</el-button>
            <el-button type="text" size="small" @click="openJsonDialog(scope.row, 'response')">响应</el-button>
          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-size="pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>

    <el-dialog title="查看JSON" :visible.sync="jsonDialogVisible" width="900px">
      <el-tabs v-model="jsonTab" type="border-card">
        <el-tab-pane label="Request JSON" name="request">
          <el-input :value="selectedRow.requestJson || ''" type="textarea" :rows="22" readonly />
        </el-tab-pane>
        <el-tab-pane label="Response JSON" name="response">
          <el-input :value="selectedRow.responseJson || ''" type="textarea" :rows="22" readonly />
        </el-tab-pane>
      </el-tabs>
      <div slot="footer">
        <el-button @click="jsonDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 订单详情弹窗 -->
    <el-dialog
      title="订单详情"
      :visible.sync="orderDetailVisible"
      width="1100px"
      :before-close="handleClose"
      custom-class="order-detail-dialog">
      <div v-if="orderDetail" class="order-detail-wrapper">
        <div class="order-detail">
          <!-- 订单基本信息卡片 -->
          <div class="detail-card order-header-card">
            <div class="card-header">
              <span class="card-title">基本信息</span>
            </div>
            <div class="card-body">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">订单号</span>
                    <span class="item-value">{{ orderDetail.orderNo }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">订单状态</span>
                    <span class="item-value">
                      <el-tag :type="getStatusTagType(orderDetail.status)" size="small">
                        {{ getStatusText(orderDetail.status) }}
                      </el-tag>
                    </span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">创建时间</span>
                    <span class="item-value">{{ orderDetail.createTime }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 交易信息卡片 -->
          <div class="detail-card">
            <div class="card-header">
              <span class="card-title">交易信息</span>
            </div>
            <div class="card-body">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">买家ID</span>
                    <span class="item-value">{{ orderDetail.buyerId }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">卖家ID</span>
                    <span class="item-value">{{ orderDetail.sellerId }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">商品ID</span>
                    <span class="item-value">{{ orderDetail.productId }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top: 16px;">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">发货方式</span>
                    <span class="item-value">{{ getShippingMethodText(orderDetail.shippingMethod) }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">支付流水</span>
                    <span class="item-value">{{ orderDetail.payNo || '--' }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">买家留言</span>
                    <span class="item-value">{{ orderDetail.buyerMessage || '--' }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 收货地址卡片 -->
          <div class="detail-card" v-if="orderDetail.addressSnapshot">
            <div class="card-header">
              <span class="card-title">收货地址</span>
            </div>
            <div class="card-body">
              <div class="address-info">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">收货人</span>
                      <span class="item-value">{{ getAddressInfo(orderDetail.addressSnapshot, 'receiverName') }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">联系电话</span>
                      <span class="item-value">{{ getAddressInfo(orderDetail.addressSnapshot, 'receiverPhone') }}</span>
                    </div>
                  </el-col>
                </el-row>
                <div class="detail-item" style="margin-top: 16px;">
                  <span class="item-label">收货地址</span>
                  <span class="item-value">
                    {{ getAddressInfo(orderDetail.addressSnapshot, 'province') }}
                    {{ getAddressInfo(orderDetail.addressSnapshot, 'city') }}
                    {{ getAddressInfo(orderDetail.addressSnapshot, 'district') }}
                    {{ getAddressInfo(orderDetail.addressSnapshot, 'detailAddress') }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- 商品信息卡片 -->
          <div class="detail-card" v-if="orderDetail.productSnapshot">
            <div class="card-header">
              <span class="card-title">商品信息</span>
            </div>
            <div class="card-body">
              <div class="product-info">
                <div class="product-info-layout">
                  <div class="product-image-wrapper">
                    <el-image
                      v-if="getProductInfo(orderDetail.productSnapshot, 'coverImage')"
                      :src="getProductInfo(orderDetail.productSnapshot, 'coverImage').split(';')[0]"
                      class="product-image"
                      fit="cover"
                      :preview-src-list="[getProductInfo(orderDetail.productSnapshot, 'coverImage').split(';')[0]]"
                    />
                  </div>
                  <div class="product-details">
                    <div class="product-title">{{ getProductInfo(orderDetail.productSnapshot, 'title') }}</div>
                    <div class="product-meta">
                      <div class="meta-item">
                        <span class="meta-label">商品ID</span>
                        <span class="meta-value">{{ getProductInfo(orderDetail.productSnapshot, 'id') }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">原价</span>
                        <span class="meta-value price-original">¥{{ getProductInfo(orderDetail.productSnapshot, 'originalPrice') }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">售价</span>
                        <span class="meta-value price-sale">¥{{ getProductInfo(orderDetail.productSnapshot, 'price') }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">地区</span>
                        <span class="meta-value">
                          {{ getProductInfo(orderDetail.productSnapshot, 'province') }}
                          {{ getProductInfo(orderDetail.productSnapshot, 'city') }}
                          {{ getProductInfo(orderDetail.productSnapshot, 'district') }}
                        </span>
                      </div>
                    </div>
                    <div class="product-desc-section">
                      <span class="desc-label">商品描述</span>
                      <div class="product-description">
                        {{ getProductInfo(orderDetail.productSnapshot, 'description') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 费用信息卡片 -->
          <div class="detail-card">
            <div class="card-header">
              <span class="card-title">费用信息</span>
            </div>
            <div class="card-body">
              <div class="price-info">
                <el-row :gutter="16">
                  <el-col :span="6">
                    <div class="price-item">
                      <div class="price-label">商品金额</div>
                      <div class="price-value">¥{{ orderDetail.productAmount }}</div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="price-item">
                      <div class="price-label">运费</div>
                      <div class="price-value">¥{{ orderDetail.shippingFee || 0 }}</div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="price-item">
                      <div class="price-label">订单总额</div>
                      <div class="price-value">¥{{ orderDetail.totalAmount }}</div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="price-item price-item-highlight">
                      <div class="price-label">实付金额</div>
                      <div class="price-value">¥{{ orderDetail.payAmount }}</div>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top: 20px;">
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">支付超时</span>
                      <span class="item-value">{{ orderDetail.payExpireTime || '--' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">支付时间</span>
                      <span class="item-value">{{ orderDetail.paidAt || '--' }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top: 16px;">
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">发货时间</span>
                      <span class="item-value">{{ orderDetail.shippedAt || '--' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">收货时间</span>
                      <span class="item-value">{{ orderDetail.receivedAt || '--' }}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>

          <!-- 物流信息卡片 -->
          <div class="detail-card" v-if="orderDetail.logistics">
            <div class="card-header">
              <span class="card-title">物流信息</span>
            </div>
            <div class="card-body">
              <div class="logistics-info">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <div class="detail-item">
                      <span class="item-label">物流公司</span>
                      <span class="item-value">{{ orderDetail.logistics.companyName }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="detail-item">
                      <span class="item-label">运单号</span>
                      <span class="item-value">{{ orderDetail.logistics.trackingNo }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="detail-item">
                      <span class="item-label">物流状态</span>
                      <span class="item-value">{{ orderDetail.logistics.status }}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 发货弹窗 -->
    <el-dialog
      title="订单发货"
      :visible.sync="shipDialogVisible"
      width="500px">
      <el-form :model="shipForm" :rules="shipRules" ref="shipForm" label-width="100px">
        <el-form-item label="物流公司" prop="logisticsCompany">
          <el-input v-model="shipForm.logisticsCompany" placeholder="请输入物流公司"></el-input>
        </el-form-item>
        <el-form-item label="运单号" prop="trackingNo">
          <el-input v-model="shipForm.trackingNo" placeholder="请输入运单号"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="shipForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入发货备注"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="shipDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitShip" :loading="shipping">确定发货</el-button>
      </div>
    </el-dialog>

    <!-- 更新状态弹窗 -->
    <el-dialog
      title="更新订单状态"
      :visible.sync="statusDialogVisible"
      width="400px">
      <el-form :model="statusForm" label-width="80px">
        <el-form-item label="订单状态">
          <el-select v-model="statusForm.status" placeholder="请选择状态" style="width: 100%;">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="statusForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="statusDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitStatusUpdate">确定</el-button>
      </div>
    </el-dialog>

    <!-- 用户详情对话框 -->
    <user-detail-dialog
      :visible.sync="userDetailVisible"
      :user-id="selectedUserId">
    </user-detail-dialog>

    <!-- 商品详情对话框 -->
    <product-detail-dialog
      :visible.sync="productDetailVisible"
      :product-id="selectedProductId">
    </product-detail-dialog>

  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  import UserDetailDialog from '../common/user-detail-dialog.vue';
  import ProductDetailDialog from '../common/product-detail-dialog.vue';

  export default {
    name: "order-stat",
    components: {
      UserDetailDialog,
      ProductDetailDialog
    },
    data () {
      return {
        // 统计数据
        statistics: {
          totalOrders: 0,
          paidOrders: 0,
          totalAmount: 0,
          paidAmount: 0
        },
        // 表格数据
        total: 0,
        tableData: [],
        searchDateArr: [],
        loading: false,
        currentPage: 1,
        pageSize: 20,
        shipping: false,
        // JSON 查看弹窗
        jsonDialogVisible: false,
        jsonTab: 'request',
        selectedRow: {},
        // 弹窗控制
        orderDetailVisible: false,
        shipDialogVisible: false,
        statusDialogVisible: false,
        orderDetail: null,
        currentOrder: null,
        // 发货表单
        shipForm: {
          id: null,
          logisticsCompany: '',
          trackingNo: '',
          remark: ''
        },
        // 状态更新表单
        statusForm: {
          id: null,
          status: '',
          remark: ''
        },
        // 用户详情弹窗
        userDetailVisible: false,
        selectedUserId: null,
        // 商品详情弹窗
        productDetailVisible: false,
        selectedProductId: null,
        // 搜索条件
        searchInfo: {
          id: '',
          orderNo: '',
          requestType: '',
          dataSign: '',
          requestJson: '',
          responseJson: '',
          succeed: '',
          errorMsg: '',
          kdnOrderCode: '',
          shipperCode: '',
          logisticCode: '',
          state: '',
          stateDesc: '',
          pushTime: '',
          callbackCreateTime: '',
          createTime: '',
          pageNumber: 0,
          pageSize: 20,
        },
        // 下拉列表数据
        statusList: [
          { label: '待支付', value: 1 },
          { label: '待发货', value: 2 },
          { label: '待收货', value: 3 },
          { label: '待评价', value: 4 },
          { label: '已完成', value: 5 },
          { label: '已取消', value: 6 },
          { label: '退款中', value: 7 },
          { label: '已退款', value: 8 }
        ],
        // 表单验证规则
        shipRules: {
          logisticsCompany: [
            { required: true, message: '请输入物流公司', trigger: 'blur' }
          ],
          trackingNo: [
            { required: true, message: '请输入运单号', trigger: 'blur' }
          ]
        },
        // 日期选择器配置
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    created() {
      this.getOrderList();
    },
    methods: {
      // 显示用户详情
      showUserDetail(userId) {
        this.selectedUserId = userId;
        this.userDetailVisible = true;
      },

      // 显示商品详情
      showProductDetail(productId) {
        this.selectedProductId = productId;
        this.productDetailVisible = true;
      },

      // 搜索
      search() {
        this.currentPage = 1;
        this.searchInfo.pageNumber = 0;
        this.getOrderList();
      },

      resetSearch() {
        this.currentPage = 1;
        this.pageSize = 20;
        this.searchInfo = {
          id: '',
          orderNo: '',
          requestType: '',
          dataSign: '',
          requestJson: '',
          responseJson: '',
          succeed: '',
          errorMsg: '',
          kdnOrderCode: '',
          shipperCode: '',
          logisticCode: '',
          state: '',
          stateDesc: '',
          pushTime: '',
          callbackCreateTime: '',
          createTime: '',
          pageNumber: 0,
          pageSize: 20,
        };
        this.getOrderList();
      },

      // 刷新统计数据
      refreshStats() {
        this.getStatistics();
      },

      // 分页处理
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val - 1;
        this.getOrderList();
      },

      handleSizeChange(val) {
        this.currentPage = 1;
        this.pageSize = val;
        this.searchInfo.pageSize = val;
        this.searchInfo.pageNumber = 0;
        this.getOrderList();
      },
      formatRequestType(requestType) {
        if (requestType === 103) return '103 - 状态推送';
        if (requestType === 701) return '701 - 查询支付结果';
        return requestType === 0 ? '0' : (requestType || '--');
      },
      formatShipperCode(code) {
        switch (code) {
          case "ZTO":
            return "中通";
          case "YTO":
            return "圆通";
          case "STO":
            return "申通";
          case "SF":
            return "顺丰";
          case "YUNDA":
          case "YD":
            return "韵达";
          case "JD":
          case "JDKY":
            return "京东";
          default:
            return code || '--';
        }
      },

      openJsonDialog(row, tab) {
        this.selectedRow = row || {};
        this.jsonTab = tab || 'request';
        this.jsonDialogVisible = true;
      },
      // 解析图片URL（分号分隔）
      parseImages(coverImage) {
        if (!coverImage) return [];
        // 分号分隔，过滤空字符串
        return coverImage.split(';').filter(img => img.trim());
      },

      // 获取订单列表
      getOrderList() {
        if (this.loading) return;
        this.loading = true;

        // 后端分页参数：pageNumber 默认 0（0基）
        const params = {
          pageNumber: this.currentPage - 1,
          pageSize: this.pageSize
        };

        // 只添加有值的搜索参数
        Object.keys(this.searchInfo).forEach(key => {
          const value = this.searchInfo[key];
          if (value !== '' && value !== null && value !== undefined) {
            params[key] = value;
          }
        });

        axios.get('/orderShipment/callback', {
          params
        }).then(result => {
          this.loading = false;
          if (result.code === 200) {
            this.total = result.data.total;
            this.tableData = result.data.list;
          } else {
            this.$message.error(result.message || '获取数据失败');
          }
        }).catch(err => {
          console.error(err);
          this.loading = false;
          this.$message.error('网络异常，请重试');
        });
      },

      // 获取统计数据
      getStatistics() {
        axios.get('/admin/order/statistics', {
          params: { period: 'month' }
        }).then(result => {
          if (result.code === 200) {
            this.statistics = result.data;
          }
        }).catch(err => {
          console.error('获取统计数据失败:', err);
        });
      },

      // 查看订单详情
      viewDetail(row) {
        this.getOrderDetail(row.id);
      },

      // 获取订单详情
      getOrderDetail(id) {
        axios.get(`/admin/order/${id}`).then(result => {
          if (result.code === 200) {
            this.orderDetail = result.data;
            this.orderDetailVisible = true;
          } else {
            this.$message.error('获取订单详情失败');
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('网络异常，请重试');
        });
      },

      // 显示发货弹窗
      showShipDialog(row) {
        this.currentOrder = row;
        this.shipForm = {
          id: row.id,
          logisticsCompany: '',
          trackingNo: '',
          remark: ''
        };
        this.shipDialogVisible = true;
      },

      // 提交发货
      submitShip() {
        this.$refs.shipForm.validate((valid) => {
          if (valid) {
            this.shipping = true;
            axios.post(`/admin/order/${this.shipForm.id}/ship`, {
              logisticsCompany: this.shipForm.logisticsCompany,
              trackingNo: this.shipForm.trackingNo,
              remark: this.shipForm.remark
            }).then(result => {
              this.shipping = false;
              if (result.code === 200) {
                this.$message.success('发货成功');
                this.shipDialogVisible = false;
                this.getOrderList();
                this.getStatistics();
              } else {
                this.$message.error(result.message || '发货失败');
              }
            }).catch(err => {
              console.error(err);
              this.shipping = false;
              this.$message.error('网络异常，请重试');
            });
          }
        });
      },

      // 查看物流信息
      viewLogistics(row) {
        // 这里可以打开物流跟踪弹窗或跳转到物流详情页面
        this.$message.info('物流跟踪功能开发中...');
      },

      // 下拉菜单命令处理
      handleCommand(command) {
        const { action, row } = command;
        if (action === 'updateStatus') {
          this.showStatusDialog(row);
        } else if (action === 'refund') {
          this.handleRefund(row);
        }
      },

      // 显示状态更新弹窗
      showStatusDialog(row) {
        this.currentOrder = row;
        this.statusForm = {
          id: row.id,
          status: row.status,
          remark: ''
        };
        this.statusDialogVisible = true;
      },

      // 提交状态更新
      submitStatusUpdate() {
        axios.put(`/admin/order/${this.statusForm.id}/status`, {
          status: this.statusForm.status,
          remark: this.statusForm.remark
        }).then(result => {
          if (result.code === 200) {
            this.$message.success('状态更新成功');
            this.statusDialogVisible = false;
            this.getOrderList();
            this.getStatistics();
          } else {
            this.$message.error(result.message || '状态更新失败');
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('网络异常，请重试');
        });
      },

      // 处理退款
      handleRefund(row) {
        this.$confirm(`确定要为订单"${row.orderNo}"申请退款吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 这里调用退款接口
          this.$message.info('退款功能开发中...');
        }).catch(() => {
          this.$message.info('已取消退款');
        });
      },

      // 双击行事件
      handleRowDblClick(row) {
        this.viewDetail(row);
      },

      // 关闭弹窗
      handleClose(done) {
        this.orderDetail = null;
        done();
      },

      // 工具方法
      formatAmount(amount) {
        if (!amount) return '¥0';
        if (amount >= 10000) {
          return '¥' + (amount / 10000).toFixed(1) + '万';
        }
        return '¥' + amount.toLocaleString();
      },

      getStatusText(status) {
        const statusMap = {
          1: '待支付',
          2: '待发货',
          3: '待收货',
          4: '待评价',
          5: '已完成',
          6: '已取消',
          7: '退款中',
          8: '已退款'
        };
        return statusMap[status] || '未知';
      },

      getStatusTagType(status) {
        const typeMap = {
          1: 'warning',
          2: 'primary',
          3: 'info',
          4: 'success',
          5: 'success',
          6: 'danger',
          7: 'warning',
          8: 'danger'
        };
        return typeMap[status] || 'info';
      },

      getShippingMethodText(shippingMethod) {
        const shippingMethodMap = {
          1: '邮寄',
          2: '面交'
        };
        return shippingMethodMap[shippingMethod] || '未知';
      },

      // 解析商品快照数据
      getProductInfo(productSnapshot, field) {
        try {
          if (typeof productSnapshot === 'string') {
            const product = JSON.parse(productSnapshot);
            return product[field] || '';
          } else if (typeof productSnapshot === 'object' && productSnapshot !== null) {
            return productSnapshot[field] || '';
          }
          return '';
        } catch (e) {
          console.error('解析商品快照失败:', e);
          return '';
        }
      },

      // 解析地址快照数据
      getAddressInfo(addressSnapshot, field) {
        try {
          if (typeof addressSnapshot === 'string') {
            const address = JSON.parse(addressSnapshot);
            return address[field] || '';
          } else if (typeof addressSnapshot === 'object' && addressSnapshot !== null) {
            return addressSnapshot[field] || '';
          }
          return '';
        } catch (e) {
          console.error('解析地址快照失败:', e);
          return '';
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .order-stat {
    .stats-cards {
      margin-bottom: 20px;

      .el-col {
        min-width: 280px;
        margin-top: 30px;
      }

      .stats-card {
        background: #fff;
        border-radius: 8px;
        padding: 10px;
        display: flex;
        align-items: center;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        min-width: 260px;
        transition: transform 0.2s ease, box-shadow 0.2s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
        }

        .stats-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #fff;
          margin-right: 16px;
          flex-shrink: 0;

          &.total {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }
          &.paid {
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
          }
          &.amount {
            background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
          }
          &.paid-amount {
            background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
          }
        }

        .stats-content {
          flex: 1;
          min-width: 0;

          .stats-number {
            font-size: 24px;
            font-weight: bold;
            color: #333;
            line-height: 1.2;
            word-break: break-all;
          }
          .stats-label {
            font-size: 14px;
            color: #666;
            margin-top: 4px;
            white-space: nowrap;
          }
        }
      }
    }
  }

  // 订单详情弹窗样式
  /deep/ .order-detail-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #e8eaec;
      padding: 20px 24px;

      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
      }
    }

    .el-dialog__body {
      padding: 0;
      background: #f5f7fa;
    }
  }

  .order-detail-wrapper {
    padding: 20px;
  }

  .order-detail {
    // 卡片基础样式
    .detail-card {
      background: #fff;
      border-radius: 8px;
      margin-bottom: 16px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
      overflow: hidden;

      &:last-child {
        margin-bottom: 0;
      }

      .card-header {
        padding: 16px 20px;
        background: linear-gradient(90deg, #f7f8fa 0%, #fff 100%);
        border-bottom: 1px solid #ebeef5;

        .card-title {
          font-size: 15px;
          font-weight: 600;
          color: #303133;
          position: relative;
          padding-left: 12px;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 16px;
            background: #409EFF;
            border-radius: 2px;
          }
        }
      }

      .card-body {
        padding: 20px;
      }
    }

    // 详情项样式
    .detail-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 0;

      .item-label {
        color: #909399;
        font-size: 14px;
        min-width: 80px;
        margin-right: 12px;
        flex-shrink: 0;
      }

      .item-value {
        color: #303133;
        font-size: 14px;
        flex: 1;
        word-break: break-all;
      }
    }

    // 收货地址样式
    .address-info {
      .detail-item {
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    // 商品信息样式
    .product-info {
      .product-info-layout {
        display: flex;
        gap: 20px;
        align-items: flex-start;
      }

      .product-image-wrapper {
        flex-shrink: 0;
      }

      .product-image {
        width: 120px;
        height: 120px;
        border-radius: 8px;
        border: 1px solid #ebeef5;
        cursor: pointer;
        transition: transform 0.2s;

        &:hover {
          transform: scale(1.02);
        }
      }

      .product-details {
        flex: 1;
        min-width: 0;

        .product-title {
          font-size: 16px;
          font-weight: 600;
          color: #303133;
          margin-bottom: 12px;
          line-height: 1.5;
          word-break: break-all;
        }

        .product-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          margin-bottom: 16px;

          .meta-item {
            display: flex;
            align-items: center;
            gap: 8px;

            .meta-label {
              color: #909399;
              font-size: 14px;
              flex-shrink: 0;
            }

            .meta-value {
              color: #303133;
              font-size: 14px;
            }
          }
        }

        .price-original {
          color: #909399;
          text-decoration: line-through;
        }

        .price-sale {
          color: #f56c6c;
          font-weight: 600;
          font-size: 16px;
        }

        .product-desc-section {
          .desc-label {
            display: block;
            color: #909399;
            font-size: 14px;
            margin-bottom: 8px;
          }
        }

        .product-description {
          padding: 12px 16px;
          background: linear-gradient(135deg, #f8f9fa 0%, #f5f7fa 100%);
          border-radius: 8px;
          color: #606266;
          font-size: 13px;
          line-height: 1.8;
          max-height: 150px;
          overflow-y: auto;
          word-break: break-all;

          &::-webkit-scrollbar {
            width: 6px;
          }

          &::-webkit-scrollbar-thumb {
            background: #dcdfe6;
            border-radius: 3px;
          }

          &::-webkit-scrollbar-track {
            background: #f5f7fa;
          }
        }
      }
    }

    // 费用信息样式
    .price-info {
      .price-item {
        text-align: center;
        padding: 16px;
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #ebeef5;
        transition: all 0.3s;

        &:hover {
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
          border-color: #c6e2ff;
        }

        .price-label {
          font-size: 13px;
          color: #909399;
          margin-bottom: 8px;
        }

        .price-value {
          font-size: 20px;
          font-weight: 600;
          color: #303133;
        }

        &.price-item-highlight {
          background: linear-gradient(135deg, #fff6e6 0%, #ffecd0 100%);
          border-color: #ffd591;

          .price-value {
            color: #e6a23c;
            font-size: 24px;
          }
        }
      }

      .detail-item {
        margin-bottom: 0;
      }
    }

    // 物流信息样式
    .logistics-info {
      .detail-item {
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .searchNav {
    padding: 16px 16px 0 16px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;

    .search-form {
      flex: 1;
      padding-right: 16px;

      .search-items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;

        .search-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          min-width: fit-content;

          .label {
            white-space: nowrap;
            color: #606266;
            font-size: 12px;
          }

          .el-input {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          .el-select {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          &.date-picker {
            .el-date-editor {
              width: 280px !important;
              /deep/ .el-input__inner {
                height: 32px;
                line-height: 32px;
              }
            }
          }
        }
      }
    }

    .search-btn {
      padding-top: 0;
      .el-button {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
        margin-left: 8px;
      }
    }
  }

  .tableStyle {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
    font-size: 12px;
  }

  @media screen and (max-width: 992px) {
    .order-stat .stats-cards {
      .el-col {
        min-width: 45%;
        margin-bottom: 20px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .searchNav {
      flex-direction: column;
      padding: 12px;

      .search-form {
        width: 100%;
        padding-right: 0;

        .search-items {
          .search-item {
            width: 100%;

            .el-input, .el-select, .el-date-editor {
              width: 100% !important;
            }
          }
        }
      }

      .search-btn {
        width: 100%;
        margin-top: 16px;
        justify-content: center;
      }
    }

    .order-stat .stats-cards {
      .el-col {
        margin-bottom: 16px;
        min-width: 100%;
      }

      .stats-card {
        min-width: auto;
      }
    }

    .order-detail-wrapper {
      padding: 12px;
    }

    .order-detail {
      .detail-card {
        .card-body {
          padding: 16px;
        }
      }

      .detail-item {
        flex-direction: column;
        align-items: flex-start;

        .item-label {
          margin-bottom: 4px;
        }
      }

      .price-info {
        .el-col {
          margin-bottom: 12px;
        }

        .price-item {
          padding: 12px;

          .price-value {
            font-size: 18px;
          }

          &.price-item-highlight .price-value {
            font-size: 20px;
          }
        }
      }

      .product-info {
        .product-info-layout {
          flex-direction: column;
        }

        .product-image {
          width: 100px;
          height: 100px;
        }

        .product-meta {
          gap: 12px;

          .meta-item {
            width: 100%;
          }
        }
      }
    }
  }

  @media screen and (max-width: 480px) {
    .order-stat .stats-cards {
      .stats-card {
        padding: 16px;

        .stats-icon {
          width: 50px;
          height: 50px;
          font-size: 20px;
          margin-right: 12px;
        }

        .stats-content {
          .stats-number {
            font-size: 20px;
          }
          .stats-label {
            font-size: 12px;
          }
        }
      }
    }
  }

  /deep/ .el-date-editor .el-range-separator {
    color: #606266 !important;
  }

  /deep/ .el-dialog__body {
    max-height: 70vh;
    overflow-y: auto;
  }

  /deep/ .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  /deep/ .el-divider__text {
    background: #fff;
    font-weight: 500;
    color: #303133;
  }

  /deep/ .el-table .warning-row {
    background: #fdf6ec;
  }

  /deep/ .el-table .success-row {
    background: #f0f9ff;
  }
</style>
